/*---

  Scripts for the header

  Louis-Charles Blais [info@22agencecreative.ca]

---*/


// Cart stuff

let cartSection = document.querySelector('.cart-section');

function cartModify() {
  cartSection.classList.add('modifying');
}

function updateCart() {
  let lineItemQuantities = document.querySelectorAll('.cart-section .line-item .quantity-input');
  let updateBody = {};
  updateBody.updates = {};
  for (let i = 0; i < lineItemQuantities.length; i++) {
    updateBody.updates[lineItemQuantities[i].dataset.lineItemKey] = Number(lineItemQuantities[i].value);
  }
  const options = {
    lastCallback: function(requestState) {
      cartSection.classList.remove('modifying');
    },
    important: true
  }
  liquidAjaxCart.update(updateBody, options);
}


// Search stuff

function searchQuery() {
  let searchInput = document.querySelector('#search-input');
  searchInput.value = event.target.innerHTML;
  event.target.closest('form').submit();
}

function performSearch() {

  let searchInput = document.querySelector('#search-input');

  if (searchInput.value.length > 1) {
    
    fetch(window.Shopify.routes.root + "search/suggest.json?q=" + searchInput.value + "&resources[type]=query,product,collection" + "&resources[limit]=5" + "&resources[limit_scope]=each" + "&resources[options][unavailable_products]=last" + "&resources[options][fields]=title,vendor,variants.title")
      .then((response) => response.json())
      .then((suggestions) => {
        let queries = suggestions.resources.results.queries;
        let products = suggestions.resources.results.products;
        let collections = suggestions.resources.results.collections;
    
        if (queries.length > 0) {
          let queriesContainer = document.querySelector('.searchbar .search-queries-container');
          queriesContainer.innerHTML = '';
          
          for (let i = 0; i < queries.length; i++) {
            let queryHtml = `
              <span class="query">${queries[i].text}</span>
            `;
            queriesContainer.insertAdjacentHTML("beforeend", queryHtml);
          }
        }

        if (products.length > 0) {
          let productsContainer = document.querySelector('.searchbar .search-products-container');
          productsContainer.innerHTML = '';
          
          for (let i = 0; i < products.length; i++) {
            let productPrice = products[i].price_min.split('.');
            let lockClass = '';
            if (products[i].tags.includes('LockPrixProduit')) {
              lockClass = 'lock';
            }
            let productCardHtml = `
              <a class="product-card small ${lockClass}" href="${products[i].url}" title="${products[i].title}">

                <div class="image-box">                      
                  <img class="main-image" src="${products[i].featured_image.url}" alt="${products[i].title}" width="200" height="200">
                </div>
              
                <div class="info">
                  <h2 class="title">${products[i].title}</h2>
                  <span class="price">${productPrice[0]}<sup>,${productPrice[1]}$</sup></span>
                  <p class="vendor">${products[i].vendor}</p>
                </div>
              
              </a>
            `;
            productsContainer.insertAdjacentHTML("beforeend", productCardHtml);
          }
        }

        if (collections.length > 0) {
          let collectionsContainer = document.querySelector('.searchbar .search-collections-container');
          collectionsContainer.innerHTML = '';
          
          for (let i = 0; i < collections.length; i++) {
            let collectionCardHtml = `
              <a class="collection-card" href="${collections[i].url}" title="${collections[i].title}">${collections[i].title}</a>
            `;
            collectionsContainer.insertAdjacentHTML("beforeend", collectionCardHtml);
          }
        }
        
      }
    );

  } else {
    
    let header = document.querySelector('header .header');
    
    fetch(window.location.pathname + '?section_id=' + header.dataset.sectionId)
    .then((response) => response.text())
    .then((responseText) => {
      const newHtml = new DOMParser().parseFromString(responseText, 'text/html');
      document.querySelector('.header .search-results').innerHTML = newHtml.querySelector('.header .search-results').innerHTML;
    });
    
  }
  
}




// Favorites stuff

let favorites;

// Set the saved module and timeframe if it exists
if (localStorage.getItem("user_favorites")) {
  favorites = JSON.parse(localStorage.getItem("user_favorites"));
} else {
  // stick with the data provided by the customer account
  if (shopify_data_favorites) {
    favorites = shopify_data_favorites;
  } else {
    favorites = [];
  }
}

function updateFavorites() {
  // check the state of header icon
  if (favorites.length > 0) {
    document.querySelector('header .favorites-widget .label').classList.add('iconoir-heart-solid');
    document.querySelector('header .favorites-widget .label').classList.remove('iconoir-heart');
  } else {
    document.querySelector('header .favorites-widget .label').classList.remove('iconoir-heart-solid');
    document.querySelector('header .favorites-widget .label').classList.add('iconoir-heart');
  }
  
  // save to local storage
  localStorage.setItem("user_favorites", JSON.stringify(favorites));
  
  // Then send to mechanic if it has changed
  if (shopify_data_favorites.length != favorites.length) {
    console.log('data has changed');
    console.log(shopify_data_favorites);
    console.log(favorites);

    let data = {};
    data.customer_id = document.querySelector('#favorites-popup').dataset.customerId;
    data.favorites = favorites;
    let fetch_data = JSON.stringify(data);
    fetch("https://webhooks.mechanic.dev/a74ebe34-833e-42df-8ffe-0735f38d7ee0", {
      method: "post",
      body: fetch_data,
      headers: {
        "content-type": "application/json",
      },
    }).then((response) => {
      console.log('Sending data to Mechanic: Success!', response);
    }).catch((error) => {
      console.error('Sending data to Mechanic: Error!', error);
    }).finally(() => {
      // confirmation
    });
  }
}

updateFavorites();


function toggleFavorite(handle) {
  if (favorites.includes(handle)) {
    event.target.classList.remove('iconoir-heart-solid');
    event.target.classList.add('iconoir-heart');
    let index = favorites.indexOf(handle);
    if (index > -1) {
      favorites.splice(index, 1);
    }
  } else {
    event.target.classList.add('iconoir-heart-solid');
    event.target.classList.remove('iconoir-heart');
    favorites.push(handle);
  }
  updateFavorites();
}


function hideFavorites() {
  document.querySelector('#favorites-popup').classList.remove('active');
}
function displayFavorites() {

  document.querySelector('#favorites-popup').classList.add('active');

  if (favorites.length > 0) {
    let favoritesContainer = document.querySelector('#favorites-popup .favorites-container');
    favoritesContainer.innerHTML = '';
  
    for (let i = 0; i < favorites.length; i++) {
      fetch(window.Shopify.routes.root + 'products/' + favorites[i] + '.js')
      .then(response => response.json())
      .then(product => {

        console.log(product);
        
        // Build the product card
        let productPriceCens = product.price_min.toString().slice(-2);
        let productPriceDollars = product.price_min.toString().slice(0, -2);
        let productCardHtml = `
          <a class="product-card small" href="${product.url}" title="${product.title}">

            <div class="image-box">      
              <i class="favorites iconoir-heart-solid" onclick="event.preventDefault(); toggleFavorite('${product.handle}');"></i>
              <img class="main-image" src="${product.featured_image}" alt="${product.title}" width="200" height="200">
            </div>
          
            <div class="info">
              <h2 class="title">${product.title}</h2>
              <span class="price">${productPriceDollars}<sup>,${productPriceCens}$</sup></span>
              <p class="vendor">${product.vendor}</p>
            </div>
          
          </a>
        `;
        
        // append the product card
        favoritesContainer.insertAdjacentHTML("beforeend", productCardHtml);
      })
      .catch(error => {
        console.log(error);
      });
    }
  }
  
}












